
import React, { Component } from 'react';
import { connect } from 'react-redux';
import CommentsList from '../shared/CommentsList';
import { Dimmer, Grid, Loader } from 'semantic-ui-react';

class CommentsTab extends Component {

  state = {
    comments: [],
    loading: false
  }

  render() {
    return (
      <Grid className="height-100 flex-container">
        <Grid.Row className="flex-stretch">
          <Grid.Column className="gs-flex-container-vertical">
            <div className="table-overflow flex-stretch-vertical">
              <Dimmer active={this.props.loading}>
                <Loader />
              </Dimmer>
              <div className="m-1">
                <CommentsList comments={this.props.data.comments} />
              </div>
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

const mapStateToProps = state => {
	return {
    data: state.collectionBreakdownModal,
  };
};

export default connect(mapStateToProps, null)(CommentsTab);